import { Component, OnInit } from '@angular/core';
import { Translate } from 'src/app/pipe/translate.pipe';

@Component({
  selector: 'app-offered-services',
  templateUrl: './offered-services.component.html',
  styleUrls: ['./offered-services.component.css']
})
export class OfferedServicesComponent implements OnInit {

  constructor(private translate: Translate) { }

  ngOnInit(): void {
  }

  getOfferedServices() {
    return this.translate.transform("OFFERED_SERVICES", 'pipeFilter') as Array<string>;
  }
  getBoxServices() {
    return this.translate.transform("BOX_SERVICES", 'pipeFilter') as Array<Array<string>>;
  }
}
